export const convertGramsToKg = (grams: number, decimal: number) => +(grams / 1000).toFixed(decimal);
